<template>
  <!-- View Aposta/Clientes Registrados -->
  <div>
    <h1 class="text-center pt-4 pb-1">{{ player_name }}</h1>
    <Resume
      :data_resume="{
        data: items,
        keys: ['sum_bet', 'sum_comission'],
        showSum: true,
        hideAlert: true,
      }"
    />
  </div>
</template>

<script>
import Resume from "@/components/backoffice/resume_global/resume";
export default {
  name: "views-dashboard-agent-registeredCustomers",
  components: {
    Resume,
  },
  data: () => ({
    player_name: "",
    items: [],
    data_resume: [],
  }),
  computed: {
    // Global Filters
    rangeGlobalDate() {
      return this.$store.state.rangeGlobal.date;
    },
    namePlayer() {
      return this.$store.state.filters.autocompleteNamePlayers.player_name;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
  },
  mounted() {
    if (this.namePlayer) {
      this.listSumBetClientAgent();
    }
  },
  watch: {
    saveFilters(val) {
      val && this.listSumBetClientAgent();
    },
  },
  methods: {
    listSumBetClientAgent() {
      var body = {
        ...this.rangeGlobalDate,
        player_name: this.namePlayer,
      };
      this.$request
        .post("/agent/clients/listSumBetClientAgent", body)
        .then((response) => {
          this.player_name = response.data.dados[0].player_name;
          this.items = response.data.dados.map((element) => {
            element.sum_comission = Number(element.sum_comission) * -1;
            return element;
          });
        })
        .catch(() => {
          this.items = [];
          this.player_name = "";
        });
    },
  },
};
</script>
